import { formatCurrency, formatDateTime } from "../../lib/formato";
import { nombreFormaPago } from "../../lib/api";
import BotonCompartir from "../BotonCompartir";
import { comprobanteDeAbono } from "../../lib/comprobante";

// Muestra el efecto de un abono sobre el saldo del cliente:
// cuánto debía antes, cuánto pagó y cuánto queda debiendo.
//
// El nombre del cliente llega por prop: quien abre el modal ya lo tiene.
const AbonoDetailModal = ({ details, cliente, onClose }) => {
  if (!details) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Detalles del abono</h2>
        {cliente && <p className="modal-subtitulo">{cliente}</p>}

        <div className="abono-detail-content">
          <p className="abono-detail-date">
            <strong>Fecha:</strong> {formatDateTime(details.fecha)}
          </p>
          {nombreFormaPago(details.metodo_pago) && (
            <p className="abono-detail-date">
              <strong>Forma de pago:</strong> {nombreFormaPago(details.metodo_pago)}
            </p>
          )}
          <ul className="abono-detail-list">
            <li>
              <span>Saldo Anterior</span>
              <span>{formatCurrency(details.saldo_anterior)}</span>
            </li>
            <li>
              <span>Monto del Abono</span>
              <span className="monto-abono">- {formatCurrency(details.monto_abono)}</span>
            </li>
            <li className="abono-total-row">
              <span>Saldo Nuevo</span>
              <span>{formatCurrency(details.saldo_nuevo)}</span>
            </li>
          </ul>
        </div>

        <div className="modal-actions modal-actions-compartir">
          {cliente && (
            <BotonCompartir
              etiqueta="Compartir comprobante"
              titulo="Comprobante de abono"
              archivo="comprobante-de-abono.png"
              generar={() =>
                comprobanteDeAbono({
                  cliente,
                  detalle: details,
                  formaPago: nombreFormaPago(details.metodo_pago),
                })
              }
            />
          )}
          <button className="btn-submit" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default AbonoDetailModal;
